import { ReactElement } from 'react';
import { Route } from 'react-router';
import { SwitchWithNotFound } from '../containers/SwitchWithNotFound';
import { NotFoundView } from '../views/errors/NotFound.view';
import { AttachmentImagePreviewView } from '../views/home/attachments/AttachmentImagePreview.view';
import { AttachmentsFolderView, AttachmentsView } from '../views/home/attachments/Attachments.view';
import { Home } from './config/Home';

export const AttachmentsRoute = (): ReactElement => (
  <SwitchWithNotFound notFound={<NotFoundView />}>
    <Route path={Home.Attachments.List.Preview.Path}>
      <AttachmentImagePreviewView />
    </Route>
    <Route path={Home.Attachments.List.Folder.Path}>
      <AttachmentsFolderView />
    </Route>
    <Route path={Home.Attachments.Path}>
      <AttachmentsView />
    </Route>
  </SwitchWithNotFound>
);
